import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CaptchaChallenge {
  token: string;
  svg: string;
  expires_in: number;
}

@Injectable({ providedIn: 'root' })
export class CaptchaService {
  private http = inject(HttpClient);
  private url = `${environment.apiUrl}/api/v3/api/captcha`;

  /** Récupère un nouveau défi captcha (jeton + image SVG). */
  get(): Observable<CaptchaChallenge> {
    return this.http.get<CaptchaChallenge>(this.url);
  }
}
